export default __webpack_public_path__ + "static/media/ls1_g03.6632538c.png";